import { useEffect, useState } from 'react';
import debounce from '@/utils/debounce';

function isWebView() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  // iOS WebView
  const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
  // Android WebView
  const isAndroidWebView =
    /\bwv\b/.test(ua) || /Android.*Version\/[\d.]+.*Chrome\/[.0-9]* Mobile/i.test(ua);
  // KakaoTalk InAppBrowser
  const isKakaoInApp = /KAKAOTALK/i.test(ua);
  // Facebook InAppBrowser
  const isFBInApp = /FBAN|FBAV/i.test(ua);

  return isIOSWebView || isAndroidWebView || isKakaoInApp || isFBInApp;
}

export const useResponsive = () => {
  const [isPCSize, setIsPCSize] = useState(window.innerWidth >= 1300);
  const [isWebviewError, setIsWebviewError] = useState(isWebView());

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsPCSize(window.innerWidth >= 1300);
      setIsWebviewError(isWebView());
    });

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isPCSize, setIsPCSize, isWebviewError };
};
